import * as Types from '../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type IdTokenQueryVariables = Types.Exact<{
  code: Types.Scalars['String'];
}>;


export type IdTokenQuery = { __typename?: 'QueryRoot', adminIdToken: { __typename?: 'IdTokenPayload', jwtToken: string } };


export const IdTokenDocument = gql`
    query IdToken($code: String!) {
  adminIdToken(code: $code) {
    jwtToken
  }
}
    `;

export function useIdTokenQuery(options: Omit<Urql.UseQueryArgs<IdTokenQueryVariables>, 'query'>) {
  return Urql.useQuery<IdTokenQuery, IdTokenQueryVariables>({ query: IdTokenDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockIdTokenQuery((req, res, ctx) => {
 *   const { code } = req.variables;
 *   return res(
 *     ctx.data({ adminIdToken })
 *   )
 * })
 */
export const mockIdTokenQuery = (resolver: ResponseResolver<GraphQLRequest<IdTokenQueryVariables>, GraphQLContext<IdTokenQuery>, any>) =>
  graphql.query<IdTokenQuery, IdTokenQueryVariables>(
    'IdToken',
    resolver
  )
